import SmrHeader from "@/components/smroom/smrheader";
import {
  Box,
  Flex,
  HStack,
  Text,
  Image,
  useToast,
  Button,
  Center,
} from "@chakra-ui/react";
import { ReactSVG } from "react-svg";
import Coin from "@/assets/design/coin.svg";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectUser } from "@/reducer/userslice";
import SmrPicture from "@/components/smroom/smrpicture/smrpicture";
import SmrDescription from "@/components/smroom/smrdescription";
import SmroomModel from "@/components/smroom/smrmodel/smrmodel";
import SmrStyle from "@/components/smroom/smrStyle/smrstyle";
import SmrImgNum from "@/components/smroom/smrnums";
import { useEffect, useState } from "react";
import SmrHistory from "@/components/smroom/smroom_history";
import historyL from "@/assets/images/smr_img9.png";
import historyR from "@/assets/images/smr_img10.png";
import { selectMode, setCurrentGen, updateDesign } from "@/reducer/modeslice";
import { genGraph, selectProgressImage } from "@/reducer/designslice";
import SmrCenterView from "@/components/smroom/smrcenterview";
import Client4 from "@/services/api/client4";
import { contentReceived, contentRemoveAll } from "@/reducer/contentSlice";

const SMRoom = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const { design, amount } = useAppSelector(selectMode);
  const toast = useToast();
  const progressImage = useAppSelector(selectProgressImage);

  const [isHistorySideOpen, setIsHistorySideOpen] = useState<boolean>(true);

  const hanleGen = () => {
    if (user && user.id) {
      const newdesign = { ...design, type: "SmrToImage" };
      dispatch(updateDesign(newdesign));

      dispatch(setCurrentGen("TXT2IMG"));
      dispatch(genGraph("txt2img"));
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  };

  

  const handleHistorySide = () => {
    setIsHistorySideOpen(!isHistorySideOpen);
  };

  useEffect(()=>{
    const fetchContent = async ()=>{
      try{
        if (user.id){
          const result = await Client4.getContents(0,9999,"",user.id)
          dispatch(contentReceived(result))
        }else{
          dispatch(contentRemoveAll())
        }
      }catch(error){
        dispatch(contentRemoveAll())
      }
    };
    fetchContent();
  },[])

  return (
    <Box bgColor={"#0C0B10"} h="100vh" overflow={"hidden"}>
      <SmrHeader />
      <Flex h="calc(100% - 70px)" justifyContent="space-between" p="1.25rem">
        {/* 左侧 */}
        <Box h="100%" w={"380px"}>
          <Flex h="100%" flexDirection={"column"}>
            <Box mb="10px" flex={1} h={0} overflow={"auto"} pr="12px">
              <SmrPicture />
              <SmrDescription />
              <SmroomModel />
              <SmrStyle />
              <SmrImgNum />
            </Box>

            <Button
              borderRadius={"60px"}
              ml={"10px"}
              color="#DCE0EB"
              width={"320px"}
              height={"60px"}
              fontSize="18px"
              fontWeight={"bold"}
              background={"linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"}
              _hover={{
                background: "linear-gradient(90deg, #496AE1 0%, #66E8E0 100%)",
              }}
              onClick={hanleGen}
              isLoading={progressImage ? true : false}
              loadingText='生图中...'
            >
                <HStack>
                <Text>开始生图</Text>
                <ReactSVG src={Coin} />
                <Text>-{amount}</Text>
              </HStack>
            </Button>
          </Flex>
        </Box>

        {/* 中间 */}

        <Box h="100%" w="0px" flex={1} ml="10px" mr="10px" border={"1px solid #6C7596"} borderRadius="10px" boxSizing="border-box">
          {progressImage ? (
            <Flex
              sx={{
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                bg:"#161922",
                borderRadius:"10px"
              }}
            >
              <Box color={"#496AE1"} fontSize="18px">
                <Center>
                  <Image
                    src={require("@/assets/images/" + progressImage.dataURL)}
                    width={progressImage.width}
                    height={progressImage.height}
                    draggable={false}
                    mb="20px"
                    sx={{
                      objectFit: "contain",
                      maxWidth: "full",
                      maxHeight: "full",
                      height: "auto",
                      // position: "absolute",
                      borderRadius: "base",
                      imageRendering: false ? "auto" : "pixelated",
                    }}
                  />
                </Center>
                <Center>生图中，请耐心等待...</Center>
              </Box>
            </Flex>
          ) :
          <SmrCenterView />}
        </Box>

        {/* 右侧 */}
        <Flex h="100%" position={"relative"}>
          <Box w="30px" h="39px"></Box>
          <Box
            w="30px"
            h="39px"
            bgColor={"#0C0B10"}
            borderLeft="1px solid #6C7596"
            borderTop="1px solid #6C7596"
            borderBottom="1px solid #6C7596"
            borderTopLeftRadius={"20px"}
            borderBottomLeftRadius={"20px"}
            textAlign="center"
            pt="6px"
            pl="3px"
            boxSizing="border-box"
            position={"absolute"}
            top="50%"
            left={"1px"}
            transform="translateY(-50%)"
            cursor={"pointer"}
            onClick={handleHistorySide}
          >
            <Image
              boxSize={"24px"}
              src={isHistorySideOpen ? historyR : historyL}
            />
          </Box>
          <Box
            w={isHistorySideOpen ? "180px" : "0px"}
            h="100%"
            border="1px solid #6C7596"
            borderRadius={"10px"}
            transition="width 0.1s ease-out"
            overflow={"hidden"}
          >
            <SmrHistory />
          </Box>
        </Flex>
      </Flex>
      
    </Box>
  );
};

export default SMRoom;
